<div class="row justify-content-between">
    <div class="col-md-6 col-lg-7 col-xl-8 col-xxl-8 d-none d-lg-block d-md-block">
        <h2 i18n="news featured news title@@news-featured-news-title"  class="widget-header h4 featured-news-title">Featured news</h2>
        <h3 class="text-muted featured-news-sub-title h6" i18n="news my news sub title@@news-featured-news-sub-title">Read the featured news from {{workplaceName}}! When you click on a post, it will open in a new tab.</h3>
    </div>
    <div class="col-md-6 col-lg-5 col-xl-4 col-xxl-4 d-none d-lg-block d-md-block">
        <h2 i18n="my news title@@my-news-title" class="widget-header h4 my-news-title">Your news</h2>
        <h3 class="text-muted h6" i18n="news my news sub title@@news-my-news-sub-title">Your personal feed. Update your channels on <a routerLink="/settings" class="settings-link action">settings page</a>.</h3>
    </div>
  </div>

<div class="row">
    <!-- large screens only -->
    <div class="col-6 col-sm-6 col-md-6 col-lg-7 col-xl-8 col-xxl-8 d-none d-lg-block d-md-block">
        <app-compact-featured-news [amountOfNewsToDisplay]="6"></app-compact-featured-news>
    </div>
    <div class="col-6 col-sm-6 col-md-6 col-lg-5 col-xl-4 col-xxl-4 d-none d-lg-block d-md-block">
        <app-compact-your-news [amountOfNewsToDisplay]="4"></app-compact-your-news>
    </div>
</div>
    <!-- Mobile screens -->
<div class="row">
  <div class="col-12 col-sm-12 col-md-12 col-xl-8 col-xxl-8 d-block d-lg-none d-md-none mt-4">
        <div class="ml-3"> 
            <h2 i18n="news featured news title@@news-featured-news-title"  class="widget-header h4 featured-news-title">Featured news</h2>
            <h3 class="text-muted featured-news-sub-title h6" i18n="news my news sub title@@news-featured-news-sub-title mb-4">Read the featured news from {{workplaceName}}! When you click on a post, it will open in a new tab.</h3>
        </div>
            <app-compact-featured-news [amountOfNewsToDisplay]="6"></app-compact-featured-news>
    </div>

</div>
<div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-xl-4 col-xxl-4 d-block d-lg-none d-md-none mt-4">
        <div class="ml-3"> 
            <h2 i18n="my news title@@my-news-title" class="widget-header h4 my-news-title">Your news</h2>
            <h3 class="text-muted h6" i18n="news my news sub title@@news-my-news-sub-title">Your personal feed. Update your channels on <a routerLink="/settings" class="settings-link action">settings page</a>.</h3>
        </div>
        <app-compact-your-news [amountOfNewsToDisplay]="6"></app-compact-your-news>
    </div>

</div>

<div class="row mt-4">
    <div class="col-auto">
      <a  mat-flat-button color="accent" *ngIf="newsCenterUrl" href="{{newsCenterUrl}}" class="news-center-button">
        <span i18n="news see all news link@@news-see-all-news-link">Go to the news center</span>
        <i class="ml-2 fa fa-external-link" aria-hidden="true"></i>
      </a>
      <a  mat-flat-button color="accent" *ngIf="!newsCenterUrl" [routerLink]="'../pages/news'" class="news-center-button">
        <span i18n="news see all news link@@news-see-all-news-link">Go to the news center</span>
        <i class="ml-2 fa fa-external-link" aria-hidden="true"></i>
      </a>
    </div>
  </div>

 
